import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';
// import { formatNumber } from 'helper';

const format = [
  { label: 'AGENCY NAME', key: 'organization_name' },
  { label: 'MASK NAME', key: 'mask_name' },
  {
    label: 'SMS COUNT',
    key: 'sms_count',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  {
    label: 'RECORDS',
    key: 'records',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  {
    label: 'TOTAL MESSAGES',
    key: 'total_messages',
    contentClassName: 'tabular-nums text-neutral-500',
  },
  // { label: 'RATE', key: 'rate' },
  // {
  //   id: 'total_amount',
  //   label: 'TOTAL AMOUNT',
  //   key: ({ total_amount }) => <span>{formatNumber(total_amount, 2)}</span>,
  // },
];

export default function SmsUsage() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
